// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"23d3b93d","237":"bae07d2e","320":"e0b315fd","453":"90e47632","519":"f7216f33","579":"fa9df323","588":"e810c246","635":"ed65926a","803":"2f8a94e2","874":"939847b6"}[chunkId] + ".chunk.js";
};